"use client";

import { Section } from "@/components/section";
import { Button } from "@/components/ui/button";
import { Meteors } from "@/components/ui/meteors";
import { motion } from "framer-motion";
import Image from "next/image";
import { useTheme } from "next-themes";
import { useState, useEffect } from "react";

export function CTA() {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // After mounting, we have access to the theme
  useEffect(() => setMounted(true), []);

  // This is backwards from what you might expect - we want light logo on dark background
  // and dark logo on light background (for better contrast)
  const logoSrc = mounted && theme === "dark" ? "/kled-io-light.png" : "/kled-io-dark.png";

  return (
    <Section id="cta">
      <div className="relative overflow-hidden rounded-xl border bg-gradient-to-br from-emerald-600 to-emerald-800 py-16 text-center mx-auto">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(16,185,129,0.3),transparent_70%)]" />
        <Meteors className="absolute inset-0" color="#10b981" quantity={20} />
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="relative z-10 px-6"
        >
          <h2 className="max-w-3xl mx-auto mb-3 text-balance font-bold text-3xl md:text-4xl text-white">
            Ready to transform your enterprise with AI/ML?
          </h2>
          
          <p className="max-w-2xl mx-auto mb-8 text-balance text-emerald-100">
            Join leading Australian organizations leveraging our GitOps architecture and Kubernetes deployment 
            for seamless AI/ML integration into their business processes.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              className="bg-gradient-to-r from-emerald-400 to-emerald-600 hover:from-emerald-500 hover:to-emerald-700 text-white font-medium px-6 py-6 h-auto shadow-lg shadow-emerald-900/30"
              size="lg"
              onClick={() => window.location.href = '/contact'}
            >
              Schedule a Demo
            </Button>
            
            <Button 
              variant="outline" 
              className="border-emerald-300 text-white hover:bg-emerald-700/50 px-6 py-6 h-auto"
              size="lg"
              onClick={() => window.location.href = '/contact'}
            >
              Contact Sales
            </Button>
          </div>
          
          <div className="mt-12">
            <div className="w-32 h-8 mx-auto relative">
              <Image 
                src={logoSrc}
                alt="Kled.io"
                fill
                style={{ objectFit: 'contain' }}
                priority
              />
            </div>
            <p className="mt-2 text-sm text-emerald-100">
              Australian-owned and operated • Secure and compliant • Enterprise-grade support
            </p>
          </div>
        </motion.div>
        
        {/* Decorative elements */}
        <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-emerald-500/20 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-emerald-600/20 blur-3xl" />
      </div>
    </Section>
  );
}
